(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sf-newsletter-popup"] && !Shopify.designMode) return;
  try {
    (() => {
 const dialog=document.getElementById('sf-newsletter');
 if(!dialog||typeof dialog.showModal!=='function')return;
 const key='sf_newsletter_last_shown_day', subscribed='sf_newsletter_subscribed';
 const today=()=>{const d=new Date();return [d.getFullYear(),d.getMonth()+1,d.getDate()].join('-')};
 const read=k=>{try{return localStorage.getItem(k)}catch{return null}};
 const save=(k,v)=>{try{localStorage.setItem(k,v)}catch{}};
 const open=()=>{if(!dialog.open)dialog.showModal()};
 dialog.querySelector('.sf-close').addEventListener('click',()=>dialog.close());
 dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}});
 const result=dialog.querySelector('[data-sf-success],[data-sf-error]');
 if(result){if(dialog.querySelector('[data-sf-success]'))save(subscribed,'1');open();return}
 const preview=new URLSearchParams(location.search).get('sf_popup')==='1';
 if(preview||window.Shopify?.designMode){open();return}
 if(read(subscribed)||read(key)===today())return;
 const attempt=()=>{
  if(read(subscribed)||read(key)===today())return;
  if(document.hidden||document.querySelector('dialog[open]')){setTimeout(attempt,1000);return}
  open();
  save(key,today());
 };
 setTimeout(attempt,8000);
})();
  } catch(e) { console.error(e); }
})();

})();
